import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const apiKey = "DakCOO7VKhWGOCVUg6F-TA";
const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

i18next
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
        fallbackLng: "pl",
        ns: ["default", "regulations", "privacypolicy", "cookies", "data-processing", "about", "how-it-works", "organizers", "faq", "price-list", "cta"],
        defaultNS: "default",
        supportedLngs: ["pl", "en"],
        backend: {
            loadPath: loadPath
        }
    })

export default i18next;
